import Icons from "../../assets/icons/index.js";
import {
  Btn,
  InputField,
  FormHeading,
  AuthLayout,
  Loader,
} from "../../components/index";
import { fontSizes } from "../../constants/constants.js";
import forgetPasswordFunction from "./index.function.js";
export default function ForgetPassword() {
  const {
    navigate,
    loadingToapi,
    errors,
    setValue,
    handleSubmit,
    onSubmit,
    register,
    TextWeight,
  } = forgetPasswordFunction();

  return (
    <AuthLayout>
      <FormHeading
        title="Forgot"
        highlightText={"Password"}
        description={"No worries, We'll send you instruction for reset"}
      />
      <form
        className="px-2 overflow-y-scroll hide-scrollbar"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="relative mt-2.5 2xl:mt-5">
          <InputField
            type="email"
            name="otpemail"
            placeholder="Email Address"
            {...register("otpemail", { required: "Email is required" })} // This registers the input with react-hook-form
            onChange={(value) => setValue("otpemail", value)}
            icon={Icons.EmailIcons}
            iconStyle={"w-5 h-5 sm:w-5 sm:h-5 lg:h-5 lg:w-6 2xl:w-7 2xl:h-6"}
          />
          {errors.otpemail && (
            <span style={{ color: "red" }}>{errors.otpemail.message}</span>
          )}
        </div>

        <Btn
          type={"submit"}
          isDisabled={loadingToapi}
          loading={loadingToapi}
          isprimary={false}
          weight={TextWeight.Raleway_SemiBold}
          textSize={fontSizes.h18}
          text={"Submit"}
          color="text-white"
          hover={"hover:text-primary hover:bg-white hover:border-primary"}
          bgColor={"bg-primary border-transparent"}
          className={"mt-4 mx-auto"}
        />
        <Btn
          type={"button"}
          isprimary={false}
          weight={TextWeight.Raleway_SemiBold}
          textSize={fontSizes.h18}
          text={"Back"}
          color="text-primary hover:text-white"
          bgColor={
            "bg-white hover:bg-primary hover:border-transparent border-primary"
          }
          className={"mt-4 mx-auto"}
          onClick={() => {
            navigate("/login");
          }}
        />
      </form>
    </AuthLayout>
  );
}
